module.exports = __webpack_public_path__ + "586e5ecbac30c847e5e037f6160904f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/rs6/clubhouse3.png
// module id = 1084
// module chunks = 0